import "./style.scss";

import { FC, useContext, useState } from "react";

import Button from "shared/ui/Button";
import PriceCard from "../PriceCard";
import { UserContext } from "features/account";
import logoVerification from "../../assets/img/Verification.svg";
import {useNavigate} from "react-router-dom";

const subjects: any = {
    modify: {
        text: "Modification de mon compte IDProtect",
        body: "Bonjour, Je souhaite modifier les informations de mon compte ID Protect.",
    },
    cancel: {
        text: "Résiliation de mon abonnement IDProtect",
        body: "Bonjour, Je souhaite résilier mon abonnement.",
    },
    buyCredits: {
        text: "Achat de vérifications IDProtect",
        body: "Bonjour, Je souhaite acheter des vérifications.",
    },
};

type BuyCreditsCardProps = {
    withSponsorModal?: boolean;
    showSponsorModal: boolean;
    setShowSponsorModal: (show: boolean) => void;
};



const BuyCreditsCard: FC<BuyCreditsCardProps> = ({ showSponsorModal, setShowSponsorModal }) => {
    const { user, userType } = useContext(UserContext);
    const credits = user?.credits;
    const userInfos = `\n-----------\n ${user?.firstname} ${user?.lastname} \n ${user?.email} \n ${user?.phoneNumber}`;

    const mailTo = (subject: string) => {
        const mail = "contact@idprotect.fr";
        window.location.href = `mailto:${mail}?subject=${subjects[subject].text}&body=${
            subjects[subject].body + encodeURIComponent(userInfos)
        }`;
    };
    const navigate = useNavigate();

    const handlePayCredit = () => {
        navigate(`${userType === 'partner' ? '/professionnels' : '/particuliers'}/credits-pricing`)
    };
    return (
        <PriceCard
            title="Vérifications"
            logo={logoVerification}
            price={credits?.toString() || "0"}
            subtitle="Vérification d'identité">
            <p>Achetez des vérifications pour contrôler la conformité d’un document et assurez vous qu’il n’est pas mis en opposition</p>

            

            <div className="d-flex flex-row align-items-center justify-content-between mt-8 mb-1 gap-2">
                <Button
                    label="Acheter"
                    size="L"
                    onClick={() => handlePayCredit()}
                    className={`btn ${userType === "partner" ? " btn-secondary" : "btn-primary"} btn-solid`}
                />

                <div
                    className="d-flex justify-content-center text-center align-items-center gap-05 ml-2">
                    <u className="pointer"
                   onClick={() => {
                    setShowSponsorModal(!showSponsorModal);
                }} >Parrainer vos proches pour gagner des credits </u>
                </div>
            </div>
        </PriceCard>
    );
};

export default BuyCreditsCard;
